export const ChordButton = ({ name, id, active, dateAdded }) => (
  <a
    class={'component__chord-button ' + (active ? 'component__chord-button--active' : '')}
    href={'#' + id}>
    {name}
  </a>
)
